module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_EN-04-1ccf8a5eedc47a206df1a0d00270e69a.svg";